import { getStore } from '../util';

const login = async ({username, password}) => {    
  const response =  await fetch(`/api/admin/login` ,{
        method: 'POST',
         headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({email: username, password: password})
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
};

const userexists = async (email) => {
    let url = `/api/admin/userexists?email=${email}`;
    const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}

const doSetPassword = async(email, password, code) => {
    const response =  await fetch(`/api/admin/resetpassword` ,{
        method: 'POST',
         headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({email: email, password: password, code:code})
    });
    if (response.ok) {
        return true
    }
    throw response;
}

const requestCode = async(email) => {
    const response =  await fetch(`/api/admin/requestcode?email=${email}` ,{
         headers: {
            'Content-Type': 'application/json'
        }
    });
    if (response.ok) {
        console.log('success')
        return true
    }
    throw response;
}

const searchUserByNumber = async (number) => {
    const user = getStore('user');
    if (number) {
        let url = `/api/admin/search-user?s=${number}`;
        const response =  await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': user.accessToken
            }
        });
        if (response.ok) {
            return response.json();
        }
        throw response;
    }
}

const addTenant = async (number, name) => {
    const user = getStore('user');
    if (number && name) {
        let url = `/api/admin/add-tenant`;
        const formData = new FormData();
        formData.append("data", JSON.stringify({name: name.trim(), contactNumber: number.trim()}));
        

        const response =  await fetch(url, {
            method: "POST",
            body: formData,
            headers: {
                'x-access-token': user.accessToken,
            }
        });
        if (response.ok) {
            return response.json();
        }
        throw response;
    }
}

export {login, userexists, doSetPassword, requestCode, searchUserByNumber, addTenant}